import SelfRateModal from './SelfRateModal';

export default SelfRateModal;
